import { Component, inject, LOCALE_ID, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageService } from './services/language.service';
import { isPlatformBrowser } from '@angular/common';
import { UnauthorizedService } from './services/unauthorized.service';
import { TokenExpired } from './utils/token-expired/token-expired';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TokenExpired],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected readonly title = signal('pims');
  private languageService = inject(LanguageService);
  private platformId = inject(PLATFORM_ID);
  unauthorizedService = inject(UnauthorizedService);
  locale = inject(LOCALE_ID);
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      const locale = this.languageService.getCurrentLocale();
      console.log('LOCALE IS:', locale);
      document.documentElement.setAttribute('dir', locale == 'ar' ? 'rtl' : 'ltr');
      document.documentElement.setAttribute('lang', locale);
    }
  }
}
